import { useEffect, useState } from 'react';
import phoneCardStyle from './phoneCardStyle.module.css'
import { useData } from "../../context/PhoneDirectoryContext";

const PhoneCard = ({ element, index }) => {
  const [activeCard, setActiveCard] = useState(()=>false)
  const {lastId } = useData();

  useEffect(() => {
    const el = document.querySelector("#d" + (lastId - 1));
    if (el) el.scrollIntoView(false);
    else {
      document.querySelector("#firstCard").scrollIntoView(false);
    }
  }, [lastId]);


  return (
    <div
      style={{ "--myorder": index + 1 }}
      id={`d${index}`}
      className={phoneCardStyle.cardContainer}
      // className= {activeCard?
      //   phoneCardStyle.activeCard:
      //   phoneCardStyle.cardContainer
      // }
      key={element.divisionName+index}
      title={element.divisionName}
      // onClick={(e) => {
      //   e.preventDefault();
      //   e.stopPropagation();
      //   for(let i=0;i<{lastId};i++){
      //     if (i !== index)
      //       document.getElementById(`d${i}`).className =  phoneCardStyle.cardContainer
      //     else
      //       document.getElementById(`d${i}`).className =  phoneCardStyle.activeCard
      //   }



      //   // setActiveCard(!activeCard)
      //   // for(let i=0;i<{lastId};i++){
      //   //   if (i !== index)document.getElementById(`d${i}`).style.zIndex = 'unset'
      //   //   else document.getElementById(`d${index}`).style.zIndex = '99'}


      // }}
      // onKeyUp={(e) => {
      //   e.preventDefault();
      //   e.stopPropagation();
      //   console.log(e);

      //   for(i=0;i<{lastId};i++){
      //     if (i !== index)document.getElementById(`d${i}`).className = phoneCardStyle.cardContainer}
      //     document.getElementById(`d${index}`).className = phoneCardStyle.activeCard
        

      // }}
    >
      <div className={phoneCardStyle.title}>
        <h4 className={phoneCardStyle.rotatedTitle}>{element.divisionName}</h4>
      </div>
      <article className={phoneCardStyle.card1} title={element.divisionName}>
        <div className={phoneCardStyle.cardCollegeHeader}>
          <span className={phoneCardStyle.collegeAvatar}>
            <h3 className={phoneCardStyle.department}>
              الجامعة الوطنية الخاصة
            </h3>
          </span>
          <div className={phoneCardStyle.collegeName}>
            {element.divisionName}
          </div>
        </div>
        <table>
          <thead>
            <tr>
              <td colSpan="3">___________________________________</td>
            </tr>
          </thead>
          <tbody>
            {element.phoneNumbers.map((person) => {
              return (
                <tr
                  key={person.serial + "" + person.phoneNumber}
                  title={person.division}
                >
                  <td>
                    {person.phonePrefix} {person.phoneName}
                  </td>
                  <td>{person.phoneNumber}</td>
                  <td>{person.cellNumber}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </article>
    </div>
  );
};
export default PhoneCard;
